export const allCurrency = ["USD", "INR", "Pound"];

export const randomColors = [
  "#dad21f",
  "#9a3ef6",
  "#d890f9",
  "#6cd4bd",
  "#b6ba6c",
  "#a48348",
  "#7b9fb8",
];

export const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const USER_ROLES = {
  ADMIN:"Admin",
  USER:"User"
}

export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_TIME_FORMAT = 'MM/DD/YYYY hh:mm A';

export const SignalREvents = {
  ReceivedMessages : {
    itemCreated: "itemCreated",
    itemFieldUpdated: "itemFieldUpdated",
    userOpendItemInEditMode: "userOpendItemInEditMode",
    itemModified: "itemModified",
    processExecutiveReview: "processExecutiveReview",
    productCommentUpdated: "productCommentUpdated",
    productActivatedDeactivated: "productActivatedDeactivated",
    exportJobUpdated: "exportJobUpdated"
  },
  SendMessages: {
    sendItemCreated: "onItemCreated"
  }
}

export const NOTIFICATION_TYPE_FRIENDLY_NAME = {
  NewProduct: "New Product",
  StageStatusTagUpdate:"Stage/Status/Tag Update",
  AttachmentUpdate: "Attachment Update", 
  AssignmentUpdate: "Assignment Update",
  ProcessExecutiveReview: "Process Executive Review",
  ProductCommentUpdate: "Product Comment Update",
  ProductActivateDeactivate: "Product Activate/Deactivate",
  AttachmentAdd: "Attachment Add",
  AttachmentRemove: "Attachment Remove",
  NewProductComment: "New Product Comment"
};

export const LEAGO_TO_PIM_FIELD_LIST = "Leago to PIM Field List";
export const EXPORT_PRODUCTS_CSV_SEQUENCE = "Export Products to CSV Field Sequence";
export const SAVED_PRODUCT_EXPORT_KEY = "saved product export";
export const maxRecordsWarningMessage = (recordsLimit: number) => `You have selected more than ${recordsLimit} records. Please select fewer records to proceed.`;